import {normalizeError} from "../libs/mk-womanizer/error";
import {toast} from "react-toastify";

let statusCodeMapping = {
    // 409 : 'Conflit, une entrée similaire existe déjà',
    // 400 : 'Certains champs sont invalides',
    // 400 : 'Une erreur est survenue, essayez de rafraîchir la page',
    401 : 'Identifiants incorrects',
    // 403 : 'Vous n\'êtes pas autorisé à executer cette action',
    415 : 'Type de fichier non supporté',
    413 : 'Fichier trop lourd',
    429 : `Trop d'actions dans un court laps de temps, veuillez patienter avant de recommencer.`,
    500 : 'Une erreur serveur est survenue, contactez un administrateur ou un membre de l\'équipe technique',
    501 : 'Cette fonctionnalité n\'est pas disponible',
    ERR_NETWORK : 'Nous rencontrons quelques difficultés merci de recommencer d\'ici quelques minutes '
};

let isToggleToast = true;

function errorNormalizer(error){
    let errorResponse = error.response || {};
    let responseData = errorResponse.data || {};
    let normalized = normalizeError({
        errors: responseData.errors,
        message: responseData.message || errorResponse.statusText,
        name: null,
        statusCode: responseData.statusCode || errorResponse.status,
        error: responseData.error || errorResponse.statusText,
    });
    if(!errorResponse.status && error.code === "ERR_NETWORK"){
        normalized = normalizeError({
            errors: {},
            message: error.message,
            name: error.name,
            statusCode: error.code,
            error: {},
        });
    }
    if(!errorResponse.status && error.code === "ECONNABORTED"){
        normalized = normalizeError({
            errors: {},
            message: error.message,
            name: error.name,
            statusCode: error.code,
            error: {},
        });
    }

    //todo: en discuter avec max mais quand l'api est down affiche un message et cancel toutes les autres requetes
    /*if(error.code === "ERR_NETWORK"){
        toast(statusCodeMapping[error.code],{
            autoClose: 10000,
            className: 'toast-background toast-error',
            bodyClassName: "toast-font toast-error",
            progressClassName: 'toast-loader toast-error'
        });
    }*/
    if(statusCodeMapping[normalized.statusCode] && isToggleToast){
        isToggleToast = false;
        toast(statusCodeMapping[normalized.statusCode],{
            autoClose: 10000,
            className: 'toast-background toast-error',
            bodyClassName: "toast-font toast-error",
            progressClassName: 'toast-loader toast-error'
        });
    }
    // if(normalized.statusCode === 404){
    //     history.push('/404');
    // }

    return {...error, response: normalized};

}

export function response(res) {
    return res.data;
}


export function responseError(error) {
    let normalizedError = errorNormalizer(error);
    return Promise.reject(normalizedError);
}

export function responseQueryError(error) {
    let normalizedError = errorNormalizer(error);

    return Promise.reject(normalizedError.response);
}

const dataInterceptor = {
    response,
    responseError,
    responseQueryError
};

export default dataInterceptor;